import { render, staticRenderFns } from "./WhereAmI.vue?vue&type=template&id=4b1d25a4&"
import script from "./WhereAmI.vue?vue&type=script&lang=js&"
export * from "./WhereAmI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports